import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  alertApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { analyticsOnboarding } from '../analytics-onboarding';
import { analyticsDetailOnboarding } from '../analytics-detail-onboarding';
import { LocalStorageOnboardingStorage } from './LocalStorageOnboardingStorage';

export function useRestartAnalyticsOnboarding() {
  const navigate = useNavigate();
  const identityApi = useApi(identityApiRef);
  const alertApi = useApi(alertApiRef);
  const [isRestarting, setIsRestarting] = useState(false);

  const restart = async () => {
    setIsRestarting(true);
    try {
      const { userEntityRef } = await identityApi.getBackstageIdentity();
      const userId = userEntityRef.split('/').pop() || '';
      const storage = new LocalStorageOnboardingStorage();
      await storage.resetProgress(userId, analyticsOnboarding.id);
      await storage.resetProgress(userId, analyticsDetailOnboarding.id);
      navigate('/analytics');
    } catch {
      alertApi.post({
        message: 'Unable to restart onboarding tips. Please try again.',
        severity: 'error',
      });
    } finally {
      setIsRestarting(false);
    }
  };

  return { restart, isRestarting };
}
